import React, { useEffect, useState } from 'react';
import {
  PERMISSIONS,
  PERMISSION_LABEL,
  PERMISSION_OPTIONS,
  SELECT_ALL,
} from '@src/constants';
import classNames from 'classnames';
import apis from '@src/apis';
import { useDispatch } from 'react-redux';
import actions from '@src/redux/actions';
import MultipleSelect from '@src/components/Muilti-Select';

import { customSelectPermissions } from './SelectPermissionStyle';
import { StyledSelectPermissions } from '../../index.style';

const SelectPermission = ({
  currentPermissions,
  accountId,
  account,
  fetchAccounts,
  onChange,
  typeHelperText,
  helperText,
  customStyle = {},
  isDisabled = false,
}) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const getValuePermissions = (option = []) => option.map((item) => item.value);

  const formatOptionLabel = ({ label, value }) => (
    <div
      className={classNames('option-label', {
        'bold-option': value === PERMISSIONS.ALL,
      })}
    >
      {label}
    </div>
  );

  const convertToSelectOptions = (values) =>
    values?.map((item) => ({
      label: PERMISSION_LABEL[item],
      value: item,
    }));

  const handleSelectChange = async (newUpdatedPermission) => {
    if (onChange) {
      onChange?.(newUpdatedPermission);
      return;
    }
    const addAllPermissions = newUpdatedPermission?.find(
      (item) => item.value === PERMISSIONS.ALL,
    );
    const payload = addAllPermissions
      ? getValuePermissions(PERMISSION_OPTIONS)
      : getValuePermissions(newUpdatedPermission);

    setIsLoading(true);
    const res = await apis.account.updateAccount({
      accountId,
      username: account.username,
      roles: account.roles,
      permissions: payload,
    });
    setIsLoading(false);

    if (!res || !res.status) {
      dispatch(
        actions.noti.push({
          severity: 'error',
          code: res?.code || 0,
        }),
      );
      return;
    }

    dispatch(
      actions.noti.push({
        severity: 'success',
        message: 'Cập nhật quyền thành công',
      }),
    );

    await fetchAccounts();
  };

  useEffect(() => {
    const permissionOptions = convertToSelectOptions(currentPermissions);

    setSelectedOptions(permissionOptions);
  }, [currentPermissions]);

  return (
    <StyledSelectPermissions>
      <MultipleSelect
        closeMenuOnSelect={false}
        isClearable={false}
        isMulti
        defaultValue={selectedOptions}
        value={selectedOptions}
        options={[...PERMISSION_OPTIONS, SELECT_ALL]}
        styles={customSelectPermissions(customStyle)}
        menuPortalTarget={document.body}
        formatOptionLabel={formatOptionLabel}
        onChange={handleSelectChange}
        isLoading={isLoading}
        placeholder="Chọn quyền cho tài khoản"
        typeHelperText={typeHelperText}
        helperText={helperText}
        isDisabled={isDisabled}
      />
    </StyledSelectPermissions>
  );
};
export default SelectPermission;
